// import initializeApplication from '../Entries/mainApplicationEntry';
// import initializeApplicationHelper from '../Entries/helperEntry';
// import initializeSearchMask from '../Entries/searchMaskEntry';
// import initializeUtilities from '../Entries/utilitiesEntry';
// import initializeSlider from '../Entries/sliderEntry'
// import initializeOfferGallery from '../Entries/offerGalleryEntry'
// import initializeHeroSlider from "../Entries/heroSliderEntry";
// import initializeTabs from '../Entries/tabsEntry'
// import initializeRating from "../Entries/ratingEntry";
// import initializeRatingMobile from "../Entries/ratingMobileEntry";
// import initializeSunRating from "../Entries/sunRatingEntry";
// import initializeNavigation from "../Entries/navigationEntry";
import initializeBurgerMenu from "../Entries/burgerMenuEntry";
import initializeTippy from "../Entries/tippyEntry";
// import initializeNewsletter from "../Entries/newsletterEntry";
// import initializePRGLink from "../Entries/prgLinkEntry";
// import initializeCountdown from "../Entries/countdownEntry";
// import initializeLanguageSwitcherLinks from "../Entries/languageSwitcherEntry";
// import initializeNewsletterExtended from "../Entries/newsletterExtendedEntry";
// import initializeAnimatedBox from "../Entries/animatedBoxEntry";
// import initializeTextFlexible from "Entries/textFlexibleEntry";
// import initializeHotelDetailBookmarkHeart from "../Entries/hotelDetailBookmarkHeartEntry";
// import initializeGame from "../Entries/gameEntry";
// import initializeWeather from "../Entries/weatherEntry";
// import initializeClimate from "../Entries/climateEntry";
//const loginEntryPromise = import('../Entries/loginEntry');
document.addEventListener('DOMContentLoaded', function () {
    document.body.className += ' loaded';
    //initializeLanguageSwitcherLinks();
    //initializeApplication();
    initializeBurgerMenu();
    initializeTippy();
    //initializeNavigation();
    //initializeSearchMask(true);
    //initializeUtilities();
    //initializeOfferGallery();
    //initializeHeroSlider();
    //initializeTabs();
    //initializeNewsletter();
    //initializeNewsletterExtended();
    //initializeCountdown();
    //initializeRating();
    //initializeRatingMobile();
    //initializeSunRating();
    //initializeHotelDetailBookmarkHeart();
    //initializeGame();
    //initializeWeather();
    //initializeClimate();
    //loginEntryPromise.then(module => setTimeout(() => module.default(),0));
});
//window.addEventListener('load', () => {
//    initializeApplicationHelper();
//    initializeLanguageSwitcherLinks();
//    initializeSlider();
//    setTimeout(() => {
//            initializePRGLink();
//            initializeTextFlexible();
//            initializeAnimatedBox();
//        }, 500
//    );
//});
//
//if ((typeof(document.getElementById('control-arrow')) != 'undefined' && document.getElementById('control-arrow') != null)&&(typeof(document.getElementById('headline')) != 'undefined' && document.getElementById('headline') != null)) {
//    document.getElementById('control-arrow').addEventListener("click", function() {
//        window.scrollTo({
//            top: document.getElementById('headline').getBoundingClientRect().top - 100,
//            behavior: 'smooth'
//        });
//    });
//}
//
//window.sessionStorage.removeItem('destination-list-sorting');
//window.sessionStorage.removeItem('hotel-list-sorting');
//
